"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BPMNProcessBuilder = void 0;
var BPMNElements_1 = require("../entities/BPMN/BPMNElements");
var BPMNSharedTypes_1 = require("../entities/BPMN/BPMNSharedTypes");
var EntitiesHelper_1 = require("../helpers/EntitiesHelper");
var SyntaxChecker_1 = require("../parser/SyntaxChecker");
var BPMNProcessBuilder = (function () {
    function BPMNProcessBuilder(process) {
        this._process = process;
        this._incomingFlows = {};
        this._outgoingFlows = {};
        this.buildIdPrefixes();
        this.buildProcess();
    }
    Object.defineProperty(BPMNProcessBuilder.prototype, "BPMN", {
        get: function () { return this._BPMN; },
        enumerable: false,
        configurable: true
    });
    BPMNProcessBuilder.prototype.buildProcess = function () {
        this._BPMN = new BPMNElements_1.BPMNProcess(this._process.$id, this._process.process);
        for (var _i = 0, _a = this._process.$nodeIds; _i < _a.length; _i++) {
            var id = _a[_i];
            this._incomingFlows[id] = [];
            this._outgoingFlows[id] = [];
        }
        if (this._process.activities !== undefined) {
            var start = true;
            for (var _b = 0, _c = this._process.activities; _b < _c.length; _b++) {
                var a = _c[_b];
                this.buildActivity(a, start);
                start = false;
            }
        }
    };
    BPMNProcessBuilder.prototype.buildActivity = function (activity, start, sub) {
        var _this = this;
        if (start === void 0) { start = false; }
        var _ref;
        if (sub !== undefined)
            _ref = sub;
        else
            _ref = this._BPMN;
        if (start) {
            var startId = this.createId('bpmn:startEvent');
            var flowId = this.createId('bpmn:sequenceFlow');
            _ref.addChild(new BPMNElements_1.BPMNSequenceFlow(flowId, startId, activity.$id));
            _ref.addChild(new BPMNElements_1.BPMNStartEvent(startId, flowId));
            this._incomingFlows[activity.$id].push(flowId);
        }
        if (activity.goto !== undefined) {
            if (SyntaxChecker_1.ConditionalGotoActivities.includes(activity.type)) {
                var goto = activity.goto;
                for (var _i = 0, goto_1 = goto; _i < goto_1.length; _i++) {
                    var gt = goto_1[_i];
                    var flowOutId = this.createId('bpmn:sequenceFlow');
                    var destId = void 0;
                    if (gt.then === undefined) {
                        destId = this.createId('bpmn:endEvent');
                        _ref.addChild(new BPMNElements_1.BPMNEndEvent(destId, flowOutId));
                    }
                    else {
                        destId = EntitiesHelper_1.EntHelper.GetIdFromName(gt.then);
                        this._incomingFlows[destId].push(flowOutId);
                    }
                    _ref.addChild(new BPMNElements_1.BPMNSequenceFlow(flowOutId, activity.$id, destId, new BPMNElements_1.BPMNConditionExpression(gt.if)));
                    this._outgoingFlows[activity.$id].push(flowOutId);
                }
            }
            else {
                var goto = activity.goto;
                for (var _a = 0, _b = EntitiesHelper_1.EntHelper.StrToStrArray(goto); _a < _b.length; _a++) {
                    var gt = _b[_a];
                    var destId = EntitiesHelper_1.EntHelper.GetIdFromName(gt);
                    var flowId = this.createId('bpmn:sequenceFlow');
                    _ref.addChild(new BPMNElements_1.BPMNSequenceFlow(flowId, activity.$id, destId));
                    this._outgoingFlows[activity.$id].push(flowId);
                    this._incomingFlows[destId].push(flowId);
                }
            }
        }
        else if (activity.xgoto !== undefined || activity.igoto !== undefined) {
            var xgt = activity.xgoto !== undefined;
            var ixgwId = this.createId(xgt ? 'bpmn:exclusiveGateway' : 'bpmn:inclusiveGateway');
            this._outgoingFlows[ixgwId] = [];
            var flowInId = this.createId('bpmn:sequenceFlow');
            this._outgoingFlows[activity.$id].push(flowInId);
            _ref.addChild(new BPMNElements_1.BPMNSequenceFlow(flowInId, activity.$id, ixgwId));
            var gotoes = xgt ? activity.xgoto : activity.igoto;
            for (var _c = 0, gotoes_1 = gotoes; _c < gotoes_1.length; _c++) {
                var gt = gotoes_1[_c];
                var flowOutId = this.createId('bpmn:sequenceFlow');
                var destId = void 0;
                if (gt.then === undefined) {
                    destId = this.createId('bpmn:endEvent');
                    _ref.addChild(new BPMNElements_1.BPMNEndEvent(destId, flowOutId));
                }
                else {
                    destId = EntitiesHelper_1.EntHelper.GetIdFromName(gt.then);
                    this._incomingFlows[destId].push(flowOutId);
                }
                _ref.addChild(new BPMNElements_1.BPMNSequenceFlow(flowOutId, ixgwId, destId, new BPMNElements_1.BPMNConditionExpression(gt.if)));
                this._outgoingFlows[ixgwId].push(flowOutId);
            }
            _ref.addChild(new BPMNElements_1.BPMNInclusiveExclusiveGateway(xgt ? 'exc' : 'inc', ixgwId, flowInId, this._outgoingFlows[ixgwId]));
        }
        else if (activity.pgoto !== undefined) {
            var pgwId = this.createId('bpmn:parallelGateway');
            this._outgoingFlows[pgwId] = [];
            var flowInId = this.createId('bpmn:sequenceFlow');
            this._outgoingFlows[activity.$id].push(flowInId);
            _ref.addChild(new BPMNElements_1.BPMNSequenceFlow(flowInId, activity.$id, pgwId));
            for (var _d = 0, _e = activity.pgoto; _d < _e.length; _d++) {
                var gt = _e[_d];
                var destId = EntitiesHelper_1.EntHelper.GetIdFromName(gt);
                var flowOutId = this.createId('bpmn:sequenceFlow');
                _ref.addChild(new BPMNElements_1.BPMNSequenceFlow(flowOutId, pgwId, destId));
                this._outgoingFlows[pgwId].push(flowOutId);
                this._incomingFlows[destId].push(flowOutId);
            }
            _ref.addChild(new BPMNElements_1.BPMNParallelGateway(pgwId, flowInId, this._outgoingFlows[pgwId]));
        }
        else {
            var endId = this.createId('bpmn:endEvent');
            var flowId = this.createId('bpmn:sequenceFlow');
            _ref.addChild(new BPMNElements_1.BPMNSequenceFlow(flowId, activity.$id, endId));
            _ref.addChild(new BPMNElements_1.BPMNEndEvent(endId, flowId));
            this._outgoingFlows[activity.$id].push(flowId);
        }
        var _act;
        switch (activity.type) {
            case 'sub':
                var subP_1 = new BPMNElements_1.BPMNSubProcess(activity.$id, activity.name, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]);
                var start_1 = true;
                activity.activities.forEach(function (element) { _this.buildActivity(element, start_1, subP_1); start_1 = false; });
                _ref.addChild(subP_1);
                break;
            case 'pgw':
                _ref.addChild(new BPMNElements_1.BPMNParallelGateway(activity.$id, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'xgw':
                _ref.addChild(new BPMNElements_1.BPMNInclusiveExclusiveGateway('exc', activity.$id, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'igw':
                _ref.addChild(new BPMNElements_1.BPMNInclusiveExclusiveGateway('inc', activity.$id, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'human':
                _ref.addChild(new BPMNElements_1.BPMNUserTask(activity.$id, activity.name, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'busin':
                _ref.addChild(new BPMNElements_1.BPMNBusinessRuleTask(activity.$id, activity.name, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'call':
                _ref.addChild(new BPMNElements_1.BPMNCallActivity(activity.$id, activity.name, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'manual':
                _ref.addChild(new BPMNElements_1.BPMNManualTask(activity.$id, activity.name, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'receive':
                _ref.addChild(new BPMNElements_1.BPMNReceiveTask(activity.$id, activity.name, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'script':
                _ref.addChild(new BPMNElements_1.BPMNScriptTask(activity.$id, activity.name, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'send':
                _ref.addChild(new BPMNElements_1.BPMNsendTask(activity.$id, activity.name, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'serv':
                _ref.addChild(new BPMNElements_1.BPMNServiceTask(activity.$id, activity.name, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'task':
                _ref.addChild(new BPMNElements_1.BPMNTask(activity.$id, activity.name, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'inthrow':
                _ref.addChild(new BPMNElements_1.BPMNIntermediateThrowEvent(activity.$id, activity.name, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'inmcatch':
                _ref.addChild(new BPMNElements_1.BPMNMessageIntermediateCatchEvent(activity.$id, activity.name, this.createId('bpmn:messageEventDefinition'), this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'inmthrow':
                _ref.addChild(new BPMNElements_1.BPMNMessageIntermediateThrowEvent(activity.$id, activity.name, this.createId('bpmn:messageEventDefinition'), this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'intimer':
                _ref.addChild(new BPMNElements_1.BPMNTimerIntermediateCatchEvent(activity.$id, activity.name, this.createId('bpmn:timerEventDefinition'), this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'inescal':
                _ref.addChild(new BPMNElements_1.BPMNEscalationIntermediateThrowEvent(activity.$id, activity.name, this.createId('bpmn:escalationEventDefinition'), this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'incond':
                _ref.addChild(new BPMNElements_1.BPMNConditionalIntermediateThrowEvent(activity.$id, activity.name, this.createId('bpmn:conditionalEventDefinition'), activity.condition, this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'incomp':
                _ref.addChild(new BPMNElements_1.BPMNCompensateIntermediateThrowEvent(activity.$id, activity.name, this.createId('bpmn:compensateEventDefinition'), this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'inscatch':
                _ref.addChild(new BPMNElements_1.BPMNSignalIntermediateCatchEvent(activity.$id, activity.name, this.createId('bpmn:signalEventDefinition'), this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
            case 'insthrow':
                _ref.addChild(new BPMNElements_1.BPMNSignalIntermediateThrowEvent(activity.$id, activity.name, this.createId('bpmn:signalEventDefinition'), this._incomingFlows[activity.$id], this._outgoingFlows[activity.$id]));
                break;
        }
    };
    BPMNProcessBuilder.prototype.createId = function (nodeName) {
        return this._idPrefixes[nodeName] + '_' + (++this._prefixesProg[nodeName]).toString();
    };
    BPMNProcessBuilder.prototype.buildIdPrefixes = function () {
        this._idPrefixes = {};
        this._prefixesProg = {};
        for (var _i = 0, BPMNNodeNames_1 = BPMNSharedTypes_1.BPMNNodeNames; _i < BPMNNodeNames_1.length; _i++) {
            var name_1 = BPMNNodeNames_1[_i];
            this._idPrefixes[name_1] = this.buildPrefix(name_1);
            this._prefixesProg[name_1] = 0;
        }
    };
    BPMNProcessBuilder.prototype.buildPrefix = function (nodeName) {
        var prefix = nodeName.substr('bpmn:'.length);
        var addPrefix = '_';
        var collision = true;
        while (collision) {
            for (var _i = 0, _a = this._process.$nodeIds; _i < _a.length; _i++) {
                var id = _a[_i];
                if (id.substr(0, prefix.length) != prefix)
                    collision = false;
                else {
                    collision = true;
                    break;
                }
            }
            if (collision)
                prefix = addPrefix + prefix;
        }
        return prefix;
    };
    return BPMNProcessBuilder;
}());
exports.BPMNProcessBuilder = BPMNProcessBuilder;
//# sourceMappingURL=BPMNProcessBuilder.js.map